import React from 'react'
import { Trans, Plural } from '@lingui/macro'
import { FollowResourceType } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { AddComment } from '../add-comment/AddComment'
import CommentsFollow from '../comments-follow/CommentsFollow'
import {
  useCommentsOnEventQuery,
  useCommentsOnTopicQuery,
  useCommentsOnPathwayQuery
} from './CommentsFooter.codegen'
import { CommentBubble } from 'front-end/src/components/common/comments/comment-bubble/CommentBubble'

export interface ICommentIdentifier {
  itemType: FollowResourceType
  itemId: number
  allowComments: boolean
}

const queries = {
  event: useCommentsOnEventQuery,
  topic: useCommentsOnTopicQuery,
  pathway: useCommentsOnPathwayQuery
}

export const CommentsFooter: React.FC<ICommentIdentifier> = (props) => {
  const { data, refetch } = queries[props.itemType]({
    fetchPolicy: 'cache-and-network',
    variables: {
      id: props.itemId
    }
  })

  const comments = data?.parent?.comments ?? []

  const commentsListTitle = () => {
    if (
      props.allowComments ||
      (!props.allowComments && comments.length !== 0)
    ) {
      return (
        <Plural
          value={comments.length}
          _0="Be the first to comment"
          one="# comment"
          other="# comments"
        />
      )
    }
    return null
  }

  return (
    <div className="comments">
      <h3 className="comments-list-title">{commentsListTitle()}</h3>
      <div className="comments-list-wrapper">
        {comments.map((comment) => (
          <CommentBubble key={comment.id} {...comment} />
        ))}
      </div>
      {props.allowComments ? (
        <span>
          <AddComment {...props} onCreated={refetch} />
          <CommentsFollow
            {...props}
            isFollowing={data?.parent?.isFollowingComments}
          />
        </span>
      ) : (
        comments.length !== 0 && (
          <h3 className="comments-closed">
            <Trans>Comments are now closed</Trans>
          </h3>
        )
      )}
    </div>
  )
}
